/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 16.10.25
 *
 */
import BaseExtraItem from "@tl/core/modules/commission/model/extras/BaseExtraItem";

export default class SessionMaterialItem extends BaseExtraItem {

	constructor(options) {
		super(options);
	}
}
